


























// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator';

@Component({
  name: 'Home',  
})
export default class Home extends Vue {
  create(){
    this.$store.myActions.CATALOGUE_REFERENCE_ENSURE()
  } 

  get curEnsId(){
    return this.$store.myGetters.userProfile.ensId || 0
  } 

  get enseigne(){
    return this.$store.myGetters.enseignes[this.curEnsId]?this.$store.myGetters.enseignes[this.curEnsId].libelle : ''
  }
}
